import { useState } from 'react'

export const useCustomPagination = (props) => {
  const { per = 4, list = [] } = props
  const [page, setPage] = useState(1)

  const prevDisabled = page === 1
  const prevOnClick = () => setPage((prevPage) => prevPage - 1)

  const nextDisabed = page * per >= list.length
  const nextOnClick = () => setPage((prevPage) => prevPage + 1)

  return {
    list: (list || []).slice((page - 1) * per, page * per),
    prevDisabled,
    prevOnClick,
    nextDisabed,
    nextOnClick,
    page,
    pagesCount: Math.ceil(list.length / per)
  }
}